import $ from 'jquery';

class mobileCalculator {
    constructor() {
        $(document).ready(() => {
            this.$tab = $('.c-gematry-calculators__tab');
            this.tabLisener();
        });
    }

    tabLisener() {
        this.$tab.click(e => {
            let targetTab = $(e.currentTarget).data('target');
            $('.c-gematry-calculators__active-tab').removeClass('c-gematry-calculators__active-tab');
            if (targetTab === 'left') {
                $('.c-gematry-calculators__text-line').removeClass(' c-gematry-calculators__active-tab-middle');
                $('.c-gematry-calculators__column-left').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__svg-left').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__calculator-text-intro').addClass(' c-gematry-calculators__active-tab');
            }
            if (targetTab === 'middle') {
                $('.c-gematry-calculators__text-line').addClass(' c-gematry-calculators__active-tab-middle');
                $('.c-gematry-calculators__break').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__checkbox-container').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__results-container').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__selected-word').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__svg-middle').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__form').addClass(' c-gematry-calculators__order');
                $('.c-gematry-calculators__clear-selected').hide();

            }
            if (targetTab === 'right') {
                $('.c-gematry-calculators__text-line').removeClass(' c-gematry-calculators__active-tab-middle');
                $('.c-gematry-calculators__selected-calculators-container').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__svg-right').addClass(' c-gematry-calculators__active-tab');
                $('.c-gematry-calculators__form').removeClass(' c-gematry-calculators__order');
                $('.c-gematry-calculators__clear-selected').addClass(' c-gematry-calculators__active-tab');
            }

        });

    }
}

export default mobileCalculator;